module.exports = __webpack_public_path__ + "static/img/uptc_logo.82ead10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/uptc_logo.svg
// module id = 9s87
// module chunks = 1